import { findByTestId } from '@testing-library/dom'
import React, { Component } from 'react'
import CalendarIcon from '../../../images/calendar.png'
import ReasonIcon from '../../../images/question.png'
import UserIcon from '../../../images/user-3-color-64px.png'
import { convertDate } from '../../function/function'
import Chevron from '../../../images/arrow-down.png'
import MoreMenu from './more_menu'
import Styled from 'styled-components'
import LoaderGif from '../../../images/Pulse-1s-51px.gif'
import Deny_leave_confirm from './deny_leave_confirm'
import axios from 'axios'
import ApproveIcon from '../../../images/check-blue.png'
import RejectIcon from '../../../images/remove.png'

const PageButton = Styled.button`
    padding: 4px;
    border: 1px solid #dedede;
    background: rgb(239, 241, 248);
    font-wight: bold;
`

class leave_web extends Component{

    constructor(){
        super()
        this.state = {
            page: 1,
            size: 1,
            denyConfirm: ""
        }
    }

    componentDidMount(){
        this.setSize()
    }

    componentDidUpdate(prevProps){
        if(prevProps != this.props){
            this.setSize()
        }
    }

    setSize = () => {
        let data = this.props.data
        let size = data.length / 10
        this.setState({
            size: Math.ceil(size)
        })
    }

    next = () => {
        let currPage = this.state.page
        if(currPage < this.state.size)
        {
            currPage++;
            this.setState({
                page: currPage
            })
        }
    }

    prev = () => {
        let currPage = this.state.page
        if(currPage > 1){
            currPage--;
            this.setState({
                page: currPage
            })
        }
    }

    last = () => {
        this.setState({
            page: this.state.size
        })
    }

    first = () => {
        this.setState({
            page: 1
        })
    }

    reject = (id) => {
        this.setState({
            denyConfirm: <Deny_leave_confirm id={id} submit={this.submitReject} cancel={() => this.setState({denyConfirm: ""})}/>
        })
    }

    submitReject = async (id, reason) => {
        let param = {reason: reason}
        let url = "/superior/denyApplicantLeave/"+id
        let resp = await axios.post(url, param)
        let data = resp.data
        if(data.success){
            this.props.fetchLeave()
            this.setState({
                denyConfirm: ""
            })
        }
    }

    render(){

        const listData = this.props.data.map((dt, index) => {
            let seq = parseInt(index) + 1
            let userApplicant = dt.userApplicant
            let profile = userApplicant.userProfile
            let date =  convertDate(dt.bookingDate)
            let background = (index%2==0) ? "none" : "#eff1f8"

            let start = 10 * this.state.page - 10 + parseInt(1)
            let finish = 10 * this.state.page
            
            if(seq >= start && seq <= finish){

                const flag = dt.flagStatus
                let isApprove = false
                let flagId = ""

                if(flag){
                    flagId = flag.id
                    if(flagId != "00000000-0000-0000-0000-aa0000000010") isApprove = true
                }

                return  <tr style={{background: background}}>
                            <td style={{padding: "10px 5px", background: "none", border: "none"}}>
                                <div style={{display: "flex", alignItems: "center"}}>
                                    <img src={UserIcon} style={{width: "18px"}}/>
                                    <div style={{marginLeft: "5px", fontSize: "14px"}}>{profile.name}</div>
                                </div>
                            </td>
                            <td style={{padding: "10px 0px", background: "none", border: "none"}}>
                                <div style={{display: "flex", alignItems: "center"}}>
                                    <img src={ReasonIcon} style={{width: "16px"}}/>
                                    <div style={{marginLeft: "5px", fontSize: "14px"}}>{dt.reasonLeave}</div>
                                </div>
                            </td>
                            <td style={{padding: "10px 0px", background: "none", border: "none", width: "150px"}}>
                                <div style={{display: "flex", alignItems: "center"}}>
                                    <img src={CalendarIcon} style={{width: "16px"}}/>
                                    <div style={{marginLeft: "5px", fontSize: "14px"}}>{date}</div>
                                </div>
                            </td>
                            <td halign="middle" style={{padding: "10px 0px", background: "none", border: "none", width: "30px"}}>
                                {
                                    (!isApprove)
                                    ?   <a className="menu-hvr">
                                            <img src={Chevron} style={{width: "18px"}}/>
                                            <MoreMenu reject={this.reject} 
                                                    scheduleId={dt.scheduleId} 
                                                    refresh={this.props.fetchLeave} style={{marginTop: "-5px"}}/>
                                        </a>
                                    :   (flagId == "00000000-0000-0000-0000-aa0000000020")
                                        ? <img src={ApproveIcon} style={{width: "14px"}}/>
                                        : <img src={RejectIcon} style={{width: "14px"}}/>
                                }
                            </td>
                        </tr>
            }
        })

        return(
            <div id="bs-leave-ls">
                {this.state.denyConfirm}
                <table style={{width: "80%"}}>
                    <thead style={{border: "none"}}>
                        <th style={{width: "250px", textAlign: "left", padding: "10px 5px", background: "none", fontWeight: "bold", border: "none", fontSize: "12px", borderBottom: "rgb(159 159 159 / 20%) 1px solid"}}>Aplicant</th>
                        <th style={{textAlign: "left", padding: "10px 0px", background: "none", border: "none", fontWeight: "bold", fontSize: "12px", borderBottom: "rgb(159 159 159 / 20%) 1px solid"}}>Reason</th>
                        <th colSpan="2" style={{width: "100px", textAlign: "left", padding: "10px 0px", background: "none", fontWeight: "bold", border: "none", fontSize: "12px", borderBottom: "rgb(159 159 159 / 20%) 1px solid"}}>Date</th>
                    </thead>
                    <tbody>
                        {
                            (this.props.data.length == 0)
                            ?   (!this.props.isLoad)
                                ? <tr><td colSpan={3} style={{textAlign: "center", padding: "50px", color: "#CCC", fontWeight: "bold"}}>No data to display</td></tr>
                                : <tr>
                                    <td colSpan="3" style={{textAlign: "center", padding: "50px"}}>
                                        <img src={LoaderGif} style={{width: "35px"}}/>
                                    </td>
                                  </tr>
                            : listData
                        }
                    </tbody>
                </table>
                {
                     (this.props.data.length > 10)
                     ?
                        <div id="ft-l-s-tbl" style={{width: "80%"}}>
                            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px 0px", borderTop: "1px solid #CCC"}}>
                                {/* <div style={{fontSize: "14px"}}>Showing 51 to 57 of 57 entries</div> */}
                                <div style={{fontSize: "14px"}}>Showing {this.state.page} of {this.state.size} pages</div>
                                <div>
                                    <PageButton onClick={this.first}>First</PageButton>
                                    <PageButton onClick={this.prev}>Prev</PageButton>
                                    <PageButton style={{minWidth: "40px"}}>{this.state.page}</PageButton>
                                    <PageButton onClick={this.next}>Next</PageButton>
                                    <PageButton onClick={this.last}>Last</PageButton>
                                </div>
                            </div>
                        </div>
                    : ""
                }
                
            </div>
        )
    }
}

export default leave_web